module.exports = __webpack_public_path__ + "img/ai10.986ac5ff.png";